export const convertBytesToMB = (bytes: number, decimals: number = 0): number => {
  return parseFloat((bytes / 1000000).toFixed(decimals));
};
